<template>
  <div class="login-container">
    <b-row class="login-column-row">
      <b-col
        sm="12"
        md="6"
        class="left-column bg--white d-flex flex-column align-items-center justify-content-center"
      >
        <div class="d-flex flex-column align-items-center header-container">
          <img
            src="@/assets/imgs/logos/hr-logo-color.png"
            alt="Public Support logo"
            class="logo-image"
          />
          <h2 class="font-md mt-5 font-family-medium">Reset Password</h2>
        </div>
        <ValidationObserver ref="observer">
          <b-form @submit.prevent="reset" @keyup.enter.prevent="reset">
            <div class="flex-column justify-content-center">
              <div class="mt-3" v-if="showError">
                <li v-for="error in errors" :key="error.message">
                  <h6
                    class="font-sm font-family-regular danger position-relative mb-3 error-1"
                  >
                    {{ error }}
                  </h6>
                </li>
              </div>
              <ValidationProvider
                rules="required|customPassword"
                name="New password"
                v-slot="{ errors }"
                vid="newPassword"
              >
                <b-form-input
                  autocomplete="off"
                  class="form-input-one"
                  size="lg"
                  type="password"
                  name="New Password Field"
                  placeholder="Enter a new Password"
                  v-model="newPassword"
                ></b-form-input>
                <h6
                  v-if="errors[0]"
                  class="font-sm font-family-regular danger position-relative error-2 error-messages"
                >
                  {{ errors[0] }}
                </h6>
              </ValidationProvider>
              <ValidationProvider
                rules="required|password:@newPassword"
                name="Confirm Password"
                vid="confirmPassword"
                v-slot="{ errors }"
              >
                <b-form-input
                  autocomplete="off"
                  class="form-input-one mt-5"
                  size="lg"
                  type="text"
                  placeholder="Confirm Password"
                  v-model="confirmPassword"
                ></b-form-input>
                <h6
                  v-if="errors[0]"
                  class="font-sm font-family-regular danger position-relative error-4"
                >
                  {{ errors[0] }}
                </h6>
              </ValidationProvider>
              <b-alert
                class="alert-btn-top alert-create-pa custom-alert mt-3"
                :show="alertDuration"
                v-if="showAlert"
                :fade="true"
                >{{ alertMsg }}</b-alert
              >
              <div class="d-flex align-items-center flex-column">
                <b-button
                  class="login-btn btn-A btn-danger mb-5 btn-pill"
                  block
                  @click.prevent="reset"
                >
                  <b-spinner
                    v-if="resetLoading"
                    style="width: 14px; height: 14px"
                    variant="light"
                    label="Spinning"
                  ></b-spinner>
                  {{ `${!resetLoading ? "Reset Password" : ""}` }}
                </b-button>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </b-col>
      <b-col
        sm="6"
        md="6"
        class="right-column bg--primary-lighter position-relative"
      >
        <div
          class="d-flex flex-column justify-content-center align-items-center"
        >
          <div class="banner-container">
            <img
              class="banner-image"
              src="@/assets/imgs/logos/banner_right_2x.png"
              alt
            />
          </div>
          <q class="font-family-regular primary-dark quote-class">{{
            quote.quote
          }}</q>
          <p class="banner-subtitle-text font-family-medium primary-dark">
            {{ quote.quotee }}
          </p>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  extend,
  ValidationProvider,
  ValidationObserver
} from "vee-validate/dist/vee-validate.full";
import { mapActions } from "vuex";
import { quotes } from "@/utils/quotes.js";
extend("required", {
  message: field => `${field} is a required field`
});
let errorMessage =
  "should have a min length of 8 chars, and must include 1 lower-case, upper-case, numeral and a special character (!@#$%^*-)";
extend("customPassword", {
  message: field => `The ${field} ${errorMessage}`,
  validate: value => {
    let notTheseChars = /["'?&/<>\s]/;
    let mustContainTheseChars = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#%^*-]).{8,}$/;
    let containsForbiddenChars = notTheseChars.test(value);
    let containsRequiredChars = mustContainTheseChars.test(value);
    if (containsRequiredChars && !containsForbiddenChars) {
      return true;
    } else {
      if (containsForbiddenChars) {
        errorMessage =
          'contains forbidden characters: " ' + " ' ? & / < > or space";
      } else {
        errorMessage =
          "should have a min length of 8 chars, and must include 1 lower-case, upper-case, numeral and a special character (!@#$%^*-)";
      }
      return false;
    }
  }
});
extend("password", {
  params: ["target"],
  validate(value, { target }) {
    return value === target;
  },
  message: "Passwords do not match"
});
export default {
  name: "ResetPassword",
  data() {
    return {
      resetLoading: false,
      newPassword: "",
      confirmPassword: "",
      alertDuration: null,
      alertMsg: "",
      showError: false,
      variant: "",
      showAlert: false,
      errors: [],
      quotesArr: quotes,
      quote: {}
    };
  },
  methods: {
    async reset() {
      const valid = await this.$refs.observer.validate();
      if (valid) {
        this.resetLoading = true;
        this.showError = false;
        const data = {
          newPassword1: this.newPassword,
          newPassword2: this.confirmPassword,
          uid: this.$route.params.uid,
          token: this.$route.params.token
        };
        // Clear before the request: a stale token makes the API reject it as "Invalid token."
        localStorage.removeItem("user-token");
        this.resetPassword(data)
          .then(() => {
            this.showAlert = true;
            this.alertDuration = 2;
            this.resetLoading = false;
            this.alertMsg = "Password Reset Successfully";
            this.showAlert = false;
            this.$router.push({ name: "Login" });
          })
          .catch(err => {
            console.log(err.response.data.newPassword2);
            this.errors = [...err.response.data.newPassword2];
            this.showError = true;
            this.alertDuration = 2;
            this.resetLoading = false;
            this.alertMsg = "Failed to reset password";
          });
      }
    },
    ...mapActions("authModule", ["resetPassword"])
  },
  components: {
    ValidationObserver,
    ValidationProvider
  },
  created() {
    let quoteIndex = Math.floor(Math.random() * this.quotesArr.length);
    this.quote = this.quotesArr[quoteIndex];
  }
};
</script>

<style lang="scss" scoped>
.login-column-row {
  margin: 0;
  height: 100%;
  overflow: hidden;
  width: 100%;
}
.right-column,
.left-column {
  height: 100vh;
}
.left-column {
  align-items: center;
}
.banner-container {
  margin-top: 15rem;
  margin-left: 6.5rem;
  margin-bottom: 2.66rem;
}
.banner-image {
  object-fit: cover;
  max-width: 438px;
}
.banner-subtitle-text {
  text-align: center;
  max-width: 47rem;
  white-space: break-spaces;
  font-size: 2.4rem;
}
.quote-class {
  font-size: 1.6rem;
  width: 58%;
  text-align: center;
  margin-bottom: 20px;
}
.logo-image {
  height: 4.5rem;
  width: auto;
}
.form-input-one,
.form-input-two,
.error-messages {
  width: 35.2rem;
  border-radius: 4px;
  margin: 1rem 0 1rem 0;
}
.form-input-one {
  margin-bottom: 2rem;
}
.form-input-two {
  margin-bottom: 1rem;
}
.login-btn {
  color: white;
  width: 20.8rem;
  max-width: 20.8rem;
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
}
.btn-icon-left-container {
  border: 1px solid #e0e0e0;
  border-radius: 2px 0px 0px 2px;
  width: 3.5rem;
  height: 3.5rem;
}
.btn-main-content {
  border: 1px solid #e0e0e0;
  border-left: none;
  border-radius: 0px 2px 2px 0px;
  width: 21rem;
}
.btn-main-content-text {
  position: relative;
  top: 0.2rem;
  left: -2.5rem;
}
.icon-arrow-right {
  width: 0.85rem;
  height: 0.85rem;
  position: absolute;
  right: 1.5rem;
}
.header-subtitle {
  max-width: 36rem;
}
.btn-A {
  margin-top: 4.5rem;
}
@media screen and (max-width: 1180px) {
  .banner-container {
    margin-left: 0;
  }
  .banner-image {
    max-width: 40vw;
  }
}

@media screen and (max-width: 1024px) {
  .login-column-row {
    overflow: auto;
  }
}
@media screen and (max-width: 876px) {
  .banner-image {
    max-width: 50vw;
  }
}
@media screen and (min-width: 576px) and (max-width: 876px) {
  .login-column-row {
    display: flex;
    flex-direction: column;
    height: auto;
  }
  .left-column,
  .right-column {
    max-width: 100%;
    flex: 0 0 100%;
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .right-column {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}
@media screen and (max-width: 600px) {
  .banner-image {
    max-width: 75vw;
  }
  .form-input-one,
  .form-input-two {
    width: 75vw;
  }
}
@media screen and (min-width: 414px) and (max-width: 576px) {
  .login-column-row {
    height: auto;
  }
}
@media screen and (max-width: 413px) {
  .left-column,
  .right-column {
    height: auto;
  }
}
</style>
